import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

const ReserveExceptionContext = createContext<any>(null);

interface DateStatus {
  dateString: string;
  date: string;
  isReservable: boolean;
  isSelected?: boolean;
}
export interface PreOrderSchedule {
  dateString: string;
  isReservable: boolean;
  reserveTime: string;
  unprocessedCount: number;
  isEnabled: boolean;
}

export const ReserveExceptionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [dateStatuses, setDateStatuses] = useState<DateStatus[]>([]);
  const [preOrderSchedules, setPreOrderSchedules] = useState<
    PreOrderSchedule[]
  >([]);
  return (
    <ReserveExceptionContext.Provider
      value={{
        dateStatuses,
        setDateStatuses,
        preOrderSchedules,
        setPreOrderSchedules,
      }}
    >
      {children}
    </ReserveExceptionContext.Provider>
  );
};

export const useReserveException = (): {
  dateStatuses: DateStatus[];
  setDateStatuses: Dispatch<SetStateAction<DateStatus[]>>;
  preOrderSchedules: PreOrderSchedule[];
  setPreOrderSchedules: Dispatch<SetStateAction<PreOrderSchedule[]>>;
} => {
  return useContext(ReserveExceptionContext);
};
